import { useState } from 'react';
import { callApi } from 'apiClient';
import { useTranslation } from 'react-i18next';
import { ResetPasswordForm } from '../resetPasswordForm/ResetPasswordForm';
import { toError } from 'shared/util/toError';

require('./ResetPasswordPage.css');

export const ResetPasswordPage = () => {
    const { t } = useTranslation();

    const [ errorMessage, setErrorMessage ] = useState('');
    const [ successMessage, setSuccessMessage ] = useState('');
    const [ submitting, setSubmitting ] = useState(false);

    const handleSubmit = async (loginOrEmailAddress: string) => {
        setSuccessMessage('');
        setErrorMessage('');
        try {
            await callApi('POST', `/api/password-reset/request`, { loginOrEmailAddress });
            setSuccessMessage(t('RESET_PASSWORD.SUCCESS_MESSAGE'));
        }
        catch (e) {
            const err = toError(e);
            setErrorMessage(t([ `ERROR.${err.message}`, 'SERVER_ERROR' ]));
            setSubmitting(false);
        }
    };

    return (
        <div id="reset-password-page">
            <ResetPasswordForm
                onSubmit={ handleSubmit }
                submitting={ submitting }
                errorMessage={ errorMessage }
                successMessage={ successMessage }
            />
        </div>
    );
};
